import { Button, ButtonProps, styled } from '@mui/material';

const StyledButtonBack = styled(Button)<ButtonProps>(({ theme }) => ({
  border: `0.1rem solid ${theme.palette.border.secondaryOutlined}`,
  padding: '0.8rem 2.2rem'
}));

export default StyledButtonBack;
